/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { CUsdtMock } from "./CUsdtMock";

export class CUsdtMockFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<CUsdtMock> {
    return super.deploy(overrides || {}) as Promise<CUsdtMock>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): CUsdtMock {
    return super.attach(address) as CUsdtMock;
  }
  connect(signer: Signer): CUsdtMockFactory {
    return super.connect(signer) as CUsdtMockFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CUsdtMock {
    return new Contract(address, _abi, signerOrProvider) as CUsdtMock;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "exchangeRateStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "initialSupply",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "uint8",
        name: "decimal",
        type: "uint8",
      },
    ],
    name: "initializeERC20Fake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeRate",
        type: "uint256",
      },
    ],
    name: "mockSetExchangeRateStored",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_underlying",
        type: "address",
      },
    ],
    name: "mockSetUnderlying",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "underlying",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
